<template>
  <header id="page-header">
    <b-navbar toggleable="md" type="inverse fixed-top">

      <b-navbar-toggle target="nav_collapse">{{ $t('message.title.menu') }}</b-navbar-toggle>

      <b-navbar-brand href="#"><h1 class="navbar-brand"><span class="foobar-logo">Foo</span><span>Bar</span><span class="foobar-logo">Beer</span></h1></b-navbar-brand>

      <b-collapse is-nav id="nav_collapse">

        <b-navbar-nav>
          <b-nav-item><a href="#" v-scroll-to="'#page-header'">{{ $t('message.title.main.home') }}</a></b-nav-item>
          <b-nav-item><a href="#" v-scroll-to="'#page-search'">{{ $t('message.title.main.search') }}</a></b-nav-item>
          <b-nav-item><a href="#" v-scroll-to="'#page-news'">{{ $t('message.title.main.news') }}</a></b-nav-item>
          <b-nav-item><a href="#" v-scroll-to="'#page-social-links'">{{ $t('message.title.main.social') }}</a></b-nav-item>
          <b-nav-item><a href="#" v-scroll-to="'#footer'">{{ $t('message.title.main.contacts') }}</a></b-nav-item>
        </b-navbar-nav>

        <b-navbar-nav class="ml-auto" v-show="$store.state.auth.editor">
          <b-nav-item href="#"><router-link to="/add-foobar"><icon name="plus"></icon>&nbsp;{{ $t('message.title.main.add') }}</router-link></b-nav-item>
        </b-navbar-nav>

        <b-navbar-nav class="ml-auto">
          <b-nav-item href="#"><router-link to="/foobars">{{ $t('message.title.main.foobars') }}</router-link></b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

  </header>
</template>

<script>
  import Vue from 'vue'
  import BootstrapVue from 'bootstrap-vue/dist/bootstrap-vue.esm'
  import VueScrollTo from 'vue-scrollto/vue-scrollto'
  import 'vue-awesome/icons'
  import Icon from 'vue-awesome/components/Icon.vue'

  Vue.use(BootstrapVue)
  Vue.use(VueScrollTo)

  export default {
    components: {
      BootstrapVue, VueScrollTo, Icon
    },
    methods: {
      updateLang(lang) {
        Vue.i18n.set(lang)
      }
    }
  }
</script>

<style>
  nav {
    background-color: #000;
  }
</style>



// WEBPACK FOOTER //
// Header.vue?db9fd352